// ---------------------------------------------------------------------------
// Application configuration and runtime state
// ---------------------------------------------------------------------------
// DEPLOYMENT NOTE: Update the `hart.token` value below when deploying to a
// new environment. In production this should be injected via a secure
// configuration mechanism rather than committed to source control.
// ---------------------------------------------------------------------------

import type { AppConfig, AppState } from './types';

/** Backend API port - backend runs on 8000, frontend typically on 3000 or 5000 */
const API_BACKEND_PORT = 8000;

/** LifeRaft dashboard: current period length and comparison window (previous period) */
export const LIFERAFT_LOOKBACK_DAYS = 7;
export const LIFERAFT_COMPARE_DAYS = 7;

// API base URL: dev UI (port 5000/3000) uses dev-server.mjs proxy → same-origin /api
function localApiBase(): string {
  if (typeof window === 'undefined') return '/api';
  const { hostname, port } = window.location;
  if (port === '5000' || port === '3000') return '/api';
  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname === '0.0.0.0';
  if (!isLocal) return '/api';
  const host = hostname === '0.0.0.0' ? 'localhost' : hostname;
  return `http://${host}:${API_BACKEND_PORT}/api`;
}
const apiBase = localApiBase();

export const CONFIG: AppConfig = {
  apiBaseUrl: apiBase,
  refreshInterval: 30_000,
  itemsPerPage: 50,
  theme: 'light',
  apiSources: {
    liferaft: {
      name: 'LifeRaft',
      baseUrl: apiBase,
      type: 'internal',
      token: null,
    },
    hart: {
      name: 'HART',
      baseUrl: apiBase,
      type: 'external',
      // This token should be provided through secure configuration at deploy time.
      token: null,
    },
  },
  currentAPI: 'liferaft',
};

export const STATE: AppState = {
  currentSection: 'dashboard',
  currentDate: new Date().toISOString().split('T')[0],
  isConnected: false,
  autoRefreshEnabled: false,
  refreshTimer: null,
  loadingRequests: new Set(),
  hartEventsData: null,
  hartPage: 0,
  hartPageCount: 50,
};

